import React from 'react';

import {SelectionView} from '@pb/kit-component-selection';

import {useDataTableSelection} from '../hooks/useDataTableSelection';

type Props = {
    index: number,
    entityId: number | string,
    totalCount: number,
    rows: Array<number | string>,
    selectionKey: string,
    onSetSelection?: (ids: Array<number | string>) => void,
    alwaysVisible?: boolean,
};

export const SelectionRow: React.FC<Props> = props => {
    const {index, entityId, totalCount, rows, selectionKey, onSetSelection, alwaysVisible} = props;
    const {setSelection, setLastCheckedIndex, rangeShift, selection} = useDataTableSelection({
        key: selectionKey,
        rows,
        onSetSelection,
    });

    if (alwaysVisible || selection.inverted || !!selection.ids.length) {
        return (
            <SelectionView {...{
                entityId,
                totalCount,
                selection,
                setSelection,
                rowIndex: index + 1,
                rangeShift,
                setLastCheckedIndex,
            }}
            />
        );
    }

    return (
        <div className="data-table_hidden-tools data-table_hidden-tools_visible">
            <SelectionView {...{
                entityId,
                totalCount,
                selection,
                setSelection,
                rowIndex: index + 1,
                rangeShift,
                setLastCheckedIndex,
            }}
            />
        </div>
    );
};
